import { ValidationError } from '../../../../../../../../core/services/validation/models/validation-error';

export const AttachmentUploadValidationErrors: {
    MULTIPLE_FILES_NOT_ALLOWED: ValidationError;
    FILE_SIZE_EXCEEDED: ValidationError;
    FILE_EXTENSION_NOT_ALLOWED: ValidationError;
    DUPLICATE_FILE_NAME: (filename: string) => ValidationError;
} = {
    MULTIPLE_FILES_NOT_ALLOWED: {
        propertyName: 'multipleFiles',
        errorMessage: 'Please select one file at a time.',
    },
    FILE_SIZE_EXCEEDED: {
        propertyName: 'fileSize',
        errorMessage: 'FCC limits file size to 10MB.',
    },
    FILE_EXTENSION_NOT_ALLOWED: {
        propertyName: 'fileExtension',
        errorMessage:
            'This file type is not supported by the FCC. PDF format is most commonly accepted. Contact EWA for assistance.',
    },
    DUPLICATE_FILE_NAME: (filename: string): ValidationError => ({
        propertyName: 'fileName',
        errorMessage: `${filename} already selected. Please try another one. File name must be unique.`,
    }),
};
